<template>
  <VueHtml2pdf
    :enable-download="false"
    :show-layout="false"
    :float-layout="true"
    :preview-modal="true"
    :paginate-elements-by-height="1400"
    filename="bol"
    :pdf-quality="2"
    :html-to-pdf-options="{
      // Attempts are improving the quality... Doesn't seem to make much difference
      image: {
        type: 'jpeg',
        quality: 1,
      },
      html2canvas: {
        dpi: 300,
        scale: 4,
        letterRendering: true,
        useCORS: true
      },
      margin: [5, 0, 5, 0],
    }"
    :ref="name"
  >
    <section slot="pdf-content" class="mx-5 my-4">
      <section class="pdf-item mb-3 text-left">
        <div class="d-flex">
          <div class="text-center" style="width: 60px;">
            <img
                src="../assets/Marley_Logo.png"
                alt="boat Logo"
                style="flex: none;"
                height="128"
                width="128"
            />
            <!-- <img
              src="../assets/Marley_Logo.png"
              alt="boat Logo"
              height="32"
              width="32"
            />
            <h3
              class="text-sm font-weight-bold text-gray-600 text-monospace"
            >
              MARLEY
              <br/>
              SHIPPING
            </h3> -->
          </div>
        </div>
      </section>
      <section class="pdf-item mb-3 d-flex text-sm justify-content-between">
        <div>
          <div>{{ response.shipper.name }}</div>
          <div>{{ response.shipper.address }}</div>
          <div>
            {{ response.shipper.city }},
            {{ response.shipper.country }} {{ response.shipper.zipCode }}
          </div>
          <div>
            Tel: {{ response.shipper.phone }}
          </div>
        </div>
        <div>
          {{ new Date().toDateString() }}
        </div>
      </section>
      <section class="pdf-item text-center mb-3">
        <h4 class="mb-0">
          Bill of Lading/Pickup Request
        </h4>
        <span>
          Exporter
        </span>
      </section>
      <section class="pdf-item mb-2">
        <table class="table table-bordered text-sm w-100">
          <tr>
            <th>Shipper</th>
            <th>Consignee</th>
          </tr>
          <tr>
            <td>
              {{ response.shipper.name }}
              <br/>
              {{ response.shipper.address }}
              <br/>
              {{ response.shipper.city }},
              {{ response.shipper.country }} {{ response.shipper.zipCode }}
              <br/>
              Tel: {{ response.shipper.phone }}
            </td>
            <td>
              {{ response.consignee.name }}
              <br/>
              {{ response.consignee.address }}
              <br/>
              {{ response.consignee.city }},
              {{ response.consignee.country }} {{ response.consignee.zipCode }}
              <br/>
              Tel: {{ response.consignee.phone }}
            </td>
          </tr>
        </table>
      </section>
      <section class="pdf-item mb-2">
        <table class="table table-bordered text-sm w-100">
          <tr>
            <th>Number</th>
            <th>Pieces</th>
            <th>Gross Weight</th>
            <th>Charge Weight</th>
            <th>Volume</th>
          </tr>
          <tr>
            <td>-</td>
            <td>{{ response.itemDetails.items.length }}</td>
            <td>{{ response.itemDetails.items.reduce((acc, item) => acc + +item.weight, 0) }}</td>
            <td>{{ response.itemDetails.items.reduce((acc, item) => acc + +item.weight, 0) }}</td>
            <td>{{ response.itemDetails.items.reduce((acc, item) => acc + +item.volume, 0) }}</td>
          </tr>
        </table>
      </section>
      <section class="pdf-item mb-2">
        <div class="div-table text-sm">
          <div class="dt-header d-flex w-100 font-weight-bold">
            <div class="border border-dark w-50 border-right-0 px-3 py-1">Details</div>
            <div class="border border-dark w-50 px-3 py-1">Charges</div>
          </div>
          <div class="dt-body d-flex w-100">
            <div class="border border-dark w-50 border-right-0 px-3 py-1">
              <div
                class="d-flex justify-content-between"
                v-for="item in response.itemDetails.items"
                :key="item.id"
              >
                <span>SEAL#{{ item.seal }}</span>
                <span>{{ item.length }}x{{ item.width }}x{{ item.height }}</span>
              </div>
            </div>
            <div class="border border-dark w-50 px-3 py-1 d-flex flex-column">
              <div class="mb-3">
                <div
                  class="d-flex justify-content-between"
                  v-for="charge in response.chargeDetails.charges"
                  :key="charge.id"
                >
                  <span>{{ charge.name }}</span>
                  <span>{{ +charge.amount | toCurrency }}</span>
                </div>
              </div>
              <div class="border-top border-dark d-flex justify-content-between">
                <span>Total</span>
                <span>
                  {{
                    response.chargeDetails.charges
                      .reduce((acc, charge) => acc + +charge.amount, 0) | toCurrency
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    <div class="html2pdf__page-break"/>
      <section class="pdf-item mt-4 mb-2">
        <h5 class="text-xs font-weight-bold">
          Terms & Conditions: All cargo tendered is subject to search and inspection as per
          TSA/Customs Rules.
        </h5>
        <ul class="text-xs">
          <li>
            <span class="text-uppercase">
              Dangerous, hazardous, or noxious cargo must be declared and all necessary documents
              pertaining to shipping hazardous cargo must be presented at time of receiving cargo.
            </span>
            Goods of flammable, explosive, corrosive, rediactive, noxious, hazardous, instable, or
            dangerous nature shipped without will description in writing to the carrier as to there
            end character, may at any time before discharge, be landed at any place, thrown over
            board, destroyed, or rendered innocuous without liability on the part of the carrier.
          </li>
          <li>
            <span class="text-uppercase">
              Packaging:
            </span>
            Packaging guidelines have been issued be the carrier. The carrier shall not be
            responsible for any damages due to improper packaging. NOT PROPERLY PACKAGED...
          </li>
<!--          <li>-->
<!--            <span class="text-uppercase">-->
<!--              Shipper, weight, load, and count:-->
<!--            </span>-->
<!--            If cargo is not packaged by the carrier, then the carrier shall have no
 responsibility-->
<!--            or liability whatsoever for the packaging, loading, shoreing, securing
and/or storing of-->
<!--            cargo or for loss or damage caused thereby or resulting their from.-->
<!--          </li>-->
        </ul>
      </section>
      <section class="pdf-item mt-4 mb-2 text-sm">
        <div>
          I agree to the terms and conditions of this contract
        </div>
        <div>
          I also declare that the items I am shipping are hereby noted as being:
        </div>
        <div class="mt-4">
          <span>
            {{ hazardous ? 'X' : '___' }}
          </span>
          Hazardous
          <span class="ml-4">
            {{ hazardous ? '___' : 'X' }}
          </span>
          Non Hazardous
        </div>
        <div class="mt-4">
          <div>
            Customer Signature
            <span class="mr-4">____________________________________</span>
            Date
            <span>____________________</span>
          </div>
          <div class="mt-3 inline">
            <div>
              EXAMINED:
              <span>_____________</span>
              YES
              <span class="ml-4">_____________</span>
              NO
            </div>
            <div>
              Receiving Clerk:
              <span class="mr-3">___________________________</span>
              DATE:
              <span class="mr-3">_____________</span>
              TIME:
              <span>_____________</span>
            </div>
          </div>
        </div>
      </section>
<!--      <div class="html2pdf__page-break"/>-->
<!--      <section class="pdf-item">-->
<!--        <h4>-->
<!--          Title-->
<!--        </h4>-->
<!--        <span>-->
<!--          Value-->
<!--        </span>-->
<!--      </section>-->
    </section>
  </VueHtml2pdf>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';

export default {
  name: 'PrintBillOfLading',
  props: [
    'name',
    'response',
  ],
  computed: {
    hazardous() {
      return this.response.itemDetails.items.reduce((acc, item) => acc || item.hazardous, false);
    },
  },
  components: {
    VueHtml2pdf,
  },
  methods: {
    generatePdf() {
      this.$refs[this.name].generatePdf();
    },
  },
  filters: {
    toCurrency(value) {
      if (typeof value !== 'number') {
        return value;
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
};
</script>

<style scoped>
.table-bordered td, .table-bordered th {
  border: 1px solid #343434;
}
</style>
